<!--<div class="text-center">
    <h2>Unassigned Leads ({{view.total}})</h2>
    <button class="epi-button" (click)="openCustomerDialog()">Add New Customer</button>
</div>-->
<kendo-expansionpanel [title]="'Unassigned Leads'"
                      [subtitle]="'Total: ' + view.total"
                      [expanded]="true">
    <div class="row">
        <div [ngClass]="isAdd ? 'col-sm-6' : 'col-sm-12'">
            <kendo-grid [data]="view"
                        [pageSize]="state.take"
                        [skip]="state.skip"
                        [sort]="state.sort"
                        [filter]="state.filter"
                        [sortable]="true"
                        [pageable]="true"
                        [filterable]="true"
                        (dataStateChange)="dataStateChange($event)">
                <ng-template kendoGridToolbarTemplate>
                    <button class="btn btn-sml btn-primary" title="Add New" tabindex="-1" (click)="addNew()" *ngIf="!isAdd"><i class="fas fa-plus"></i></button>
                </ng-template>
                <kendo-grid-column field="customerName" title="Customer">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <!--<a (click)="openCustomerProfile(dataItem.customerCode)">{{dataItem.customerName}}</a>-->
                        <a href="/#/customer-detail/{{dataItem.customerCode}}" target="_blank">{{dataItem.customerName}}</a>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="customerCode" title="Customer 3x3"></kendo-grid-column>
                <kendo-grid-span-column>
                    <kendo-grid-column field="address1" title="Address"></kendo-grid-column>
                    <kendo-grid-column field="cityName" title="City"></kendo-grid-column>
                    <kendo-grid-column field="stateAbbrev" title="St"></kendo-grid-column>
                    <kendo-grid-column field="zip" title="Zip"></kendo-grid-column>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div>
                            {{dataItem.address1}}<br />
                            {{dataItem.cityName}}, {{dataItem.stateAbbrev}} {{dataItem.zip}}
                        </div>
                    </ng-template>
                </kendo-grid-span-column>
                <kendo-grid-column field="customerStatus" title="Status"></kendo-grid-column>
                <kendo-grid-column title="Sales Rep" field="salesRepName">
                </kendo-grid-column>
                <kendo-grid-column title="Ops Rep" field="opsRepName">
                </kendo-grid-column>
                <kendo-grid-column title="Account Rep" field="accountRepName">
                </kendo-grid-column>
            </kendo-grid>
        </div>
        <div class="col-sm-6" *ngIf="isAdd">
            <!-- Edit Child Customer form -->
            <!--<customer-child-form [parentCustomerID]="parentCustomerID" (onRefresh)="cancelEdit()"></customer-child-form>-->
            <button type="button" (click)="cancelEdit()">Cancel</button>
        </div>
    </div>
</kendo-expansionpanel>

<div class="spinner_container dark-overlay" [ngClass]="{'dark-overlay':isLoading}" *ngIf="isLoading">
    <mat-spinner style="left: 50%; top: 50%" *ngIf="isLoading"></mat-spinner>
</div>
